<div class="wrapper">
	<div class="logo_wrapper">
		<img src="../../../assets/tresen/smoothr_logo.svg" alt="Smoothr logo" />
	</div>

	<h1 class="title">
		{{ 'new_email_info_modal.title' | translate }}
	</h1>

	<div class="info-block">
		<p [innerHTML]="'new_email_info_modal.paragraph1' | translate"></p>

		<a href="mailto:{{ 'new_email_info_modal.email' | translate }}" class="link">
			{{ 'new_email_info_modal.email' | translate }}
		</a>

		<p #paragraph2 [innerHTML]="'new_email_info_modal.paragraph2' | translate"></p>

		<p (click)="goToExternalLink()" class="link">2025_09_15_Special-News_E-Mail-Distribution-Structure_Restaurant_KW36.pdf</p>

		<p class="note">
			{{ 'new_email_info_modal.note' | translate }}
		</p>
	</div>

	<div class="footer-btn">
		<button (click)="close()">
			{{ 'common.close' | translate }}
		</button>
	</div>
</div>
